<template>
  <div class="low-battery-component">
    <div class="row">
      <div class="col-sm-4">
        <vue-form ref="form"
        :options="{ permalink: 'generateBatteryList' }"
        @load="refresh()">
          <div class="card-header" slot="title">
            <span class="fa fa-fw fa-battery-quarter fa-lg"></span> Generate List
          </div>
          <template slot="actions">
            <div class="col-sm-8 offset-sm-4">
              <button type="button" class="btn btn-default" @click="refresh()">
                <span class="fa fa-fw fa-sync"></span> Refresh
              </button>
              <button type="button" class="btn btn-primary" @click="send()">
                <span class="fa fa-paper-plane fa-fw"></span> Send
              </button>
            </div>
          </template>
        </vue-form>
      </div>
      <div class="col-sm-8">
        <responsive-table :table="batteryList" @orderColumn="order($event)" default-sort-column="suburb" default-sort="ASC">
          <template v-for="(car, i) in cars" slot="rows">
            <tr :key="i" v-if="i === 0 || car.Lot.postcode != cars[i-1].Lot.postcode" class="bg-primary text-white">
              <td colspan="4">
                <strong class="bigger"><span class="fa fa-map fa-fw"></span> &nbsp;{{ car.Lot.suburb }}, {{ car.Lot.postcode }}</strong>
              </td>
            </tr>
            <tr :key="i">
              <td>
                <router-link :to="{ path: `/fleet/vehicles/${car.uuid}` }">
                  #{{ car.convadisId }} ({{ car.name }} - {{ car.rego }})
                </router-link>
              </td>
              <td>{{ car.Lot.address }} </td>
              <td>
                <span v-if="car.Reservations.length > 0">
                  <router-link :to="{path: `/fleet/reservations/${car.Reservations[0].uuid}`}">
                    {{ car.Reservations[0].reservationId }} - {{ car.Reservations[0].startDate | date_format(car.Reservations[0].Lot.timezone) }}
                  </router-link>
                  <span v-if="car.Reservations[0].maintenance" class="badge badge-danger">Maintenance</span>
                </span>
                <span v-else class="text-muted">No reservations have been made on this car</span>
              </td>
              <td>{{ car.lastIgnitionOn }}</td>
            </tr>
          </template>
        </responsive-table>
        <template v-if="cars.length == 0">
          <div class="form-section-info">All cars have been used in the last few days.</div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import VueForm from '@/components/Form'
import ResponsiveTable from '@/components/ResponsiveTable'
import Api from '@/vuex/api'
import { MODIFY_FORM_VALUE } from '@/vuex/types'

export default {
  name: 'BatteryList',
  components: {
    ResponsiveTable,
    VueForm
  },
  data () {
    return {
      cars: [],
      selectedOrganization: false,
      columns: [
        { title: 'Car', span: 4, name: 'convadisId', sort: true },
        { title: 'Suburb', span: 3, name: 'suburb', sort: true },
        { title: 'Last Reservation', span: 3, name: 'lastReservation' },
        { title: 'Last Ignition On', span: 2, name: 'lastIgnitionOn', sort: true }
      ]
    }
  },
  computed: {
    batteryList () {
      return {
        title: 'Car Battery List',
        count: this.cars.length,
        columns: this.columns,
        rows: this.cars
      }
    }
  },
  methods: {
    async refresh () {
      let instance = new Api()
      let formData = this.$refs.form.serializeForm()
      let cars = await instance.generateBatteryList(formData)
      this.cars = cars
    },
    send () {
      this.$store.commit(MODIFY_FORM_VALUE, {
        permalink: 'generateBatteryList',
        name: 'cars',
        value: this.cars
      })
      this.$refs.form.submitForm()
    },
    order (col) {
      if (col.sortDirection.includes('ASC')) {
        this.cars.sort((a, b) => {
          if (a.suburb) {
            return a[col.name] > b[col.name]
          } else {
            return a[col.name] < b[col.name]
          }
        })
      } else {
        this.cars.sort((a, b) => {
          if (a.suburb) {
            return a[col.name] < b[col.name]
          } else {
            return a[col.name] > b[col.name]
          }
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/BatteryList.vue